/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import * as pathConstants from '../../constants/pathConstants';
import FileUploadForm from './FileUploadForm';
import * as FormName from '../../constants/formNameConstants';
import {searchForFormById} from '../../selectors/searchForForm';
import * as FileUploadConstants from '../../constants/fileUploadConstants';
import * as formUploadActions from '../../actions/fileUploadActions';
import { cleanInputData } from '../common/Utility';


export class FileUploadPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formName: this.props.formName,
      fileForm: this.props.fileForm,
      fileUploadAgreement: false,
      formIsValid: false,
      fileContents: null,
      fileName: '',
      uploadFailed: true,
      error: null,
      downloadUrl: null,
    };

    this.handleClick = this.handleClick.bind(this);
    this.submit = this.submit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.checkFileExtension = this.checkFileExtension.bind(this);
  }
  onCancel(event) {
    event.preventDefault();
    browserHistory.push(pathConstants.pathToHome);
  }
  submit(event) {
    event.preventDefault();
    this.props.actions.uploadFile(this.state.fileContents, this.state.fileName)
      .then(response => {
        if(response){
          // Check if file upload has failed. This is not returned
          // for all scenarios and for success scenarios, hence
          // checking for existence of field as well.
          if ('upload_status' in response && response.upload_status == 'failed') {
            this.setState({
              error: FileUploadConstants.FILE_NOT_UPLOADED,
              uploadFailed: true,
              formIsValid: false
            }, function() {
              window.scrollTo(0,0);
            });
          }
          else {
            this.setState({
              uploadFailed: false,
              fileUploadAgreement: false,
              formIsValid: false
            });
          }
        } else {
          this.setState({error: FileUploadConstants.FILE_NOT_UPLOADED});
        }
        window.scrollTo(0,0);
      })
      .catch(error => {
        this.setState({uploadFailed: true});
        throw(error);
      });
      let fileInput = document.getElementById("file-upload");
      fileInput.value = "";
    return false;
  }

  handleClick() {


    let canUpload = this.state.fileUploadAgreement;
    if (canUpload === true) { //check
      canUpload = false;
    }
    else {
      canUpload = true;
    }
    if(this.state.fileContents && canUpload && !this.state.error) {
      this.setState({formIsValid:true});
    } else {
      this.setState({formIsValid: false});
    }
    this.setState({fileUploadAgreement: canUpload});
  }




  uploadFile(event) {
    event.preventDefault();
    let reader = new FileReader();
    let file = event.target.files[0];
    this.setState({fileName: file.name});
    const CSV = "csv";
    if(this.checkFileExtension(file.name) === CSV &&
      file.size < FileUploadConstants.MAX_FILE_SIZE){
      this.setState({error: null, uploadFailed: true});

      // READER FUNCTION
      reader.onload = (e) => {
        this.onLoad(e);
      };

      reader.readAsText(file);
    } else if(this.checkFileExtension(file.name)!==CSV){
      this.setState({
        error: FileUploadConstants.FILE_WRONG_FORMAT,
        uploadFailed: true,
        formIsValid: false
      }, function() {
        window.scrollTo(0,0);
      });
    } else if(file.size > FileUploadConstants.MAX_FILE_SIZE){
      this.setState({
        error: FileUploadConstants.FILE_TOO_LARGE,
        formIsValid: false
      }, function() {
        window.scrollTo(0,0);
      });

    }


  }

  onLoad(e) {

  const fileContents = e.target.result;
  // Matches non ascii charachters.
  const regex = /[^\x00-\x7F]|[~!#$%&*()?;:<>/@^]/g;
  const customPattern = window.customSummarDataRegex || regex;

  // Check if the file can be encoded to base64
  try {
    if (customPattern.test(fileContents)) {
      throw new Error('non-alphanumeric detected.');
    } else {
      btoa(fileContents);
    }
  } catch (error) {
      // replace non-ASCII characters
      cleanedFile = cleanInputData(fileContents);
      // Parse the csv content
      const rows = cleanedFile.split(/\r\n|\n|\r/).filter(row => row.trim() !== '');
      const headerColumns = rows[0].split(',');
      const columnCount = headerColumns.length;

      // Make sure rows have expected num of columns
      const cleanedRows = rows.map(row => {
        const columns = row.split(',').map(column => column.trim());
        // If the number of columns is less than expected, fill with empty strings
        while (columns.length < columnCount) {
          columns.push('');
        }
        // If the number of columns is more than expected, truncate the excess columns
        return columns.slice(0, columnCount).join(',');
      });
      // Reconstruct the cleaned CSV content
      const cleanedCSV = cleanedRows.join('\n');

      // create new file without non-ASCII characters
      const cleanedBlob = new Blob([cleanedCSV], { type: 'text/csv' });
      const downloadUrl = URL.createObjectURL((cleanedBlob));

      this.setState({
        error: FileUploadConstants.FILE_NOT_ENCODABLE,
        uploadFailed: true,
        formIsValid: false,
        fileContents: null,
        downloadUrl: downloadUrl
      }, () => {
        window.scrollTo(0, 0);
      });

    return;
  }

  this.setState({ fileContents });

  if (this.state.fileUploadAgreement) {
    this.setState({ formIsValid: true });
  }


    //**** Implementing Validations by Manuel Trujillo
    //*
    //*************************************************
    try{
        var myVar = 0;
        var myVar2 = 0;
        var index;
        var itemindex;
        var myChar;
        var myRows = -1;
        var strHeaderTot = '';
        var EstArray = [];
        // Dictionary mapping column index to column names starting from column 13
        const columnNames = {
          13: 'Annual Average Employees',
          14: 'Total Hours Worked',
          15: 'Number of Injuries/Illnesses',
          16: 'Total Deaths',
          17: 'Total DAFW Cases',
          18: 'Total DJTR Cases',
          19: 'Total Other Cases',
          20: 'Total DAFW Days',
          21: 'Total DJTR Days',
          22: 'Total Injuries',
          23: 'Total Skin Disorders',
          24: 'Total Respiratory Conditions',
          25: 'Total Poisonings',
          26: 'Total Hearing Loss',
          27: 'Total Other Illnesses'
        };

         if (myVar != 1){

            //validating number of headers in CSV
            var delimiter = ',';
            var escape = '\n';
            var rows = fileContents.split(escape);
            for (index in rows)
            {
                  myRows++;
                  myChar = '';
                  myVar2 = 0;
                  itemindex= -1;

                  // Total number of elemnts in header should be 28
                  if (myRows == 0 )
                  {
                      var items = rows[index].split(delimiter);
                      for (itemindex in items)
                      {
                          myChar = myChar + items[itemindex] +';';
                          myVar++;

                      }
                     if (myVar != 28 && strHeaderTot == '')
                     {
                         strHeaderTot = 'Error: Uploaded file contains an incorrect number of header columns. File should contain 28 header columns, file uploaded has ' + myVar + '.';
                         this.setState(
                                       {
                                          error: strHeaderTot,
                                          uploadFailed: true,
                                          formIsValid: false
                                       }, function() {
                                                        window.scrollTo(0,0);
                                                      }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                     }



                  }
                  else {
                              var items2 = rows[index].split(/,(?=(?:(?:[^"]*"[^"]*"))*[^"]*$)/);
                              var errorRow = myRows + 1;
                              for (itemindex in items2)
                              {
                                  myChar = items2[itemindex];

                                  myVar2++;
                                  /* Establishment name validation*/
                                  if (myVar2 == 1 && items2[itemindex].length > 0){
                                      if(EstArray.find(element => element == myChar) != undefined ){
                                          this.setState(
                                                        {
                                                           error: 'Error: Your CSV has an issue with multiples records with the same Establishment name. The duplicated information in the CSV file is column[' + myVar2 + '], row[' + errorRow + ']. Please review and edit your CSV for these errors. \n',
                                                           uploadFailed: true,
                                                           formIsValid: false
                                                        }, function() {
                                                                         window.scrollTo(0,0);
                                                                       }
                                                       );
                                                       setTimeout(() => {  location.reload();}, 30000);
                                      }
                                      EstArray.push(myChar);
                                  }

                                  /* Establishment type validation*/
                                  if (myVar2 == 11 && (myChar < 1 || myChar > 3) && items2[itemindex].length > 0){
                                      this.setState(
                                                    {
                                                       error: 'Error: Your CSV has an issue with the Establishment Type in column[' + myVar2 + '], row[' + errorRow + ']. Please use the values 1, 2 or 3 only where 1 = private sector facility; 2 = state government facility; and 3 = local government facility. Please review and edit your CSV for these errors. \n',
                                                       uploadFailed: true,
                                                       formIsValid: false
                                                    }, function() {
                                                                     window.scrollTo(0,0);
                                                                   }
                                                   );
                                                   setTimeout(() => {  location.reload();}, 30000);
                                  }
                                  // Establishment type should be a number.
                                  if (myVar2 == 11 && (!/^[0-9]+$/.test(myChar)) && items2[itemindex].length > 0){
                                    this.setState(
                                      {
                                        error: 'Error: Your CSV has an issue with the Establishment Type in column[' + myVar2 + '], row[' + errorRow + ']. Please use only numbers for the Establishment Type where 1 = private sector facility; 2 = state government facility; and 3 = local government facility. Please review and edit your CSV for these errors. \n',
                                        uploadFailed: true,
                                        formIsValid: false
                                      }, function() {
                                        window.scrollTo(0,0);
                                      }
                                    );
                                    setTimeout(() => {  location.reload();}, 30000);
                                  }
                                  // Establishment type cannot be empty.
                                  if (myVar2 == 11 && (myChar === '') && items2[itemindex].length > 0){
                                    this.setState(
                                      {
                                        error: 'Error: Your CSV has an issue with the Establishment Type in column[' + myVar2 + '], row[' + errorRow + ']. Establistment type cannot be empty, Please use only numbers for the Establishment Type where 1 = private sector facility; 2 = state government facility; and 3 = local government facility. Please review and edit your CSV for these errors. \n',
                                        uploadFailed: true,
                                        formIsValid: false
                                      }, function() {
                                        window.scrollTo(0,0);
                                      }
                                    );
                                    setTimeout(() => {  location.reload();}, 30000);
                                  }
                                  // Establishment type empty validation.
                                  if (myVar2 == 11) {
                                    if(myChar === ''){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the Establishment Type in column[' + myVar2 + '], row[' + errorRow + ']. Establistment type cannot be empty, Please use only numbers for the Establishment Type where 1 = private sector facility; 2 = state government facility; and 3 = local government facility. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                                  // Ein Validation.
                                  if (myVar2 == 2) {
                                    if(myChar.length > 0 && !/^[0-9]+$/.test(myChar)){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the EIN in column[' + myVar2 + '], row[' + errorRow + ']. EIN must contain 9 digits. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                                  // Naics Code Validation
                                  if (myVar2 == 8) {
                                    // If naics code is empty.
                                    if(myChar === ''){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the NAICS code in column[' + myVar2 + '], row[' + errorRow + ']. NAICS Code is required. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                    // If naics code is not a number.
                                    if(myChar.length > 0 && !/^[0-9]+$/.test(myChar)){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the NAICS code in column[' + myVar2 + '], row[' + errorRow + ']. Invalid NAICS Code. NAICS must contain 6 digits. See http://www.census.gov/naics. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                                  // Size Validation
                                  if (myVar2 == 10) {
                                    // If Size  is empty.
                                    if(myChar === ''){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the Size in column[' + myVar2 + '], row[' + errorRow + ']. Establishment Size is required. See 300A instructions for details. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                    // If Size is not a number.
                                    if(myChar.length > 0 && !/^[0-9]+$/.test(myChar)){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the Size in column[' + myVar2 + '], row[' + errorRow + ']. Invalid Establishment Size. See 300A instructions for details. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                                  // Filing year validation
                                  if (myVar2 == 12) {
                                    // If filing year is empty.
                                    if(myChar === ''){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the Filing Year in column[' + myVar2 + '], row[' + errorRow + ']. Filing Year is required. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                    // If filing year is not a number.
                                    if(myChar.length > 0 && !/^[0-9]+$/.test(myChar)){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the Filing Year in column[' + myVar2 + '], row[' + errorRow + ']. Filing Year must be the previous calendar year. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                                  // Form 300A validation (numerica values only).
                                  if (myVar2 >= 13 && myVar2 <= 27 && (!/^\d+$/.test(myChar)) && myVar2 != 19) {
                                    const columnName = columnNames[myVar2] || `Column ${myVar2}`;
                                    if(myChar === ''){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the ' + columnName + ' in column[' + myVar2 + '], row[' + errorRow + ']. ' + columnName + ' is required. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                    // If number value is not number.
                                    if(!/^\d+$/.test(myChar)){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the ' + columnName + ' in column[' + myVar2 + '], row[' + errorRow + '] must be a number greater than or equal to zero. Please review and edit your CSV for these errors.\n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                                  // Other cases validation (numerica values only).
                                  if (myVar2 == 19) {
                                    if(myChar.length > 0 && !/^\d+$/.test(myChar)){
                                      this.setState(
                                        {
                                          error: 'Error: Your CSV has an issue with the Number of other recordable cases in column[' + myVar2 + '], row[' + errorRow + ']. Number of other recordable cases must be a number greater than or equal to zero. Please review and edit your CSV for these errors. \n',
                                          uploadFailed: true,
                                          formIsValid: false
                                        }, function() {
                                          window.scrollTo(0,0);
                                        }
                                      );
                                      setTimeout(() => {  location.reload();}, 30000);
                                    }
                                  }
                              }
                              if (myVar != myVar2 && strHeaderTot == '' && items2[itemindex].length > 0)
                              {
                                  strHeaderTot = 'Error: Your CSV has an issue with the column headers, you exceeded number of 28 defined headers, at column['  + myVar2  +  '], row[' + errorRow +  ']. Please ensure the headers are only the ones provided by CSV Template. Please review and edit your CSV for these errors.\n';
                                  this.setState(
                                                {
                                                   error: strHeaderTot,
                                                   uploadFailed: true,
                                                   formIsValid: false
                                                }, function() {
                                                                 window.scrollTo(0,0);
                                                               }
                                               );
                                               setTimeout(() => {  location.reload();}, 30000);
                              }

                         }
                  //-----------------------------------------------


            }
           //==============================



         }

     }catch(error){
         this.setState({
           error: 'Error in CSV validations',
           uploadFailed: true,
           formIsValid: false,
           fileContents: null
       } ,function() {
           window.scrollTo(0,0);
         });
         setTimeout(() => {  location.reload();}, 10000);
     }

    //***************************************************



  }

  scrollToTop(){
    window.scrollTo(0,0);
  }

  checkFileExtension(filename) {
    const fileParts = filename.split('.');
    return fileParts[fileParts.length -1];
  }





  render() {
    return (

        <FileUploadForm
          form={this.props.fileForm}
          onSubmit={this.submit}
          onClick={this.handleClick}
          onCancel={this.onCancel}
          uploadFile={this.uploadFile}
          formIsValid={this.state.formIsValid}
          error={this.state.error}
          uploadFailed={this.state.uploadFailed}
          fileUploadAgreement={this.state.fileUploadAgreement}
          downloadUrl={this.state.downloadUrl}/>
    );
  }
}

FileUploadPage.propTypes = {
  actions: PropTypes.object.isRequired,
  fileForm: PropTypes.object.isRequired,
  formName: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};


function mapStateToProps(state) {
  let fileForm = {},
    formName = FormName.itaFileUpload;

  if (state.forms.length > 0) {
    fileForm =
      searchForFormById(state.forms, FormName.itaFileUploadId);
  }
  return {
    fileForm: fileForm,
    formName: formName,
    user: state.user[state.user.length - 1] || {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(formUploadActions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(FileUploadPage);



/** WEBPACK FOOTER **
 ** ./src/components/fileUpload/FileUploadPage.js
 **/